import { Route } from 'react-router-dom';
import Fuse from 'fuse.js';
import React from 'react';
import Sidebar from 'Components/Layout/Sidebar';
import { getHidenTickets, getTicketsByProjects, getQueriesByCity } from './api';
import createRoutes from '../routes';
import SidebarTickets from './screens/components/SidebarTickets';
import Snackbar from './screens/components/SnackBar';

const SupplyState = React.createContext({
  fetchProjects: () => {},
});

class Supply extends React.Component {
  state = {
    tickets: [],
    errors: null,
    slipCreatedMsg: 'Luminaire successfully created',
    slipUpdateMsg: 'Luminaire successfully updated',
    showSlipCreatedMsg: false,
    showUpdateCreatedMsg: false,
    hidenTickets: null,
    activeButton: 'queries',
    loading: true,
  };

  static Consumer = SupplyState.Consumer;

  componentDidMount() {
    this.fetchProjects();
  }

  getStateAndHelpers = () => {
    return {
      fetchProjects: this.fetchProjects,
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      this.props.location.state &&
      this.props.location.state.slipCreated === true
    ) {
      window.scrollTo(0, 0);
      this.fetchProjects();
      this.setState({ showSlipCreatedMsg: true });
    } else if (
      this.props.location.pathname !== prevProps.location.pathname &&
      this.props.location.state &&
      this.props.location.state.slipUpdated === true
    ) {
      window.scrollTo(0, 0);
      this.fetchProjects();
      this.setState({ showSlipCreatedMsg: true, showUpdateCreatedMsg: true });
    } else if (this.state.activeButton !== prevState.activeButton) {
      this.fetchProjects();
    }
  }

  resetStateForMessage = () => {
    this.setState({
      showSlipCreatedMsg: false,
      showUpdateCreatedMsg: false,
    });
  };

  confirmState = tickets => {
    this.setState({ tickets, loading: false });
  };

  fetchProjects = async (searchTerm, sort, order) => {
    this.setState({
      loading: true,
    });
    let data;
    try {
      if (this.state.activeButton === 'project') {
        data = await getTicketsByProjects(searchTerm, sort, order);
      } else if (this.state.activeButton === 'queries') {
        data = await getQueriesByCity(searchTerm, sort, order);
      } else data = await getHidenTickets(searchTerm, sort, order);
      this.confirmState(data.data);
      // this.setState({
      //   loading: false,
      //   tickets: data.data,
      // });
    } catch (e) {
      this.setState({
        loading: false,
        errors: e,
        tickets: [],
      });
    }
  };

  fetchHidenTickets = async () => {
    try {
      const data = await getHidenTickets();
      this.setState({
        hidenTickets: data.data,
      });
    } catch (e) {
      this.setState({
        errors: e,
      });
    }
  };

  getTicketsBy = param => () => {
    if (this.state.activeButton === param) return;
    this.setState({
      activeButton: param,
    });
  };

  getProjectByTerm = serachTerm => {
    this.fetchProjects(serachTerm);
  };

  getProjectSorted = (serachTerm, sort, order) => {
    this.fetchProjects(serachTerm, sort, order);
  };

  render() {
    return (
      <React.Fragment>
        {this.state.showSlipCreatedMsg === true ? (
          <Snackbar
            open={true}
            msg={
              this.state.showUpdateCreatedMsg
                ? this.state.slipUpdateMsg
                : this.state.slipCreatedMsg
            }
            resetState={this.resetStateForMessage}
          />
        ) : null}
        <Sidebar>
          <Route
            render={props => (
              <SidebarTickets
                tickets={this.state.tickets}
                hidenTickets={this.state.hidenTickets}
                errors={this.state.errors}
                loading={this.state.loading}
                activeButton={this.state.activeButton}
                getTicketsBy={this.getTicketsBy}
                getProjectByTerm={this.getProjectByTerm}
                getProjectSorted={this.getProjectSorted}
                {...props}
              />
            )}
          />
        </Sidebar>
        <SupplyState.Provider value={this.getStateAndHelpers()}>
          {createRoutes(this.props.match.path).map((route, i) => {
            return (
              <Route
                key={i}
                path={route.path}
                component={route.component}
                exact={route.exact}
              />
            );
          })}
        </SupplyState.Provider>
      </React.Fragment>
    );
  }
}

export default Supply;
